import { useState, useEffect, useRef } from "react";
import { Palette, Check } from "lucide-react";

export const THEMES = [
  { id: "gold", name: "Imperial Gold", swatch: "rgb(212 175 55)" },
  { id: "royal", name: "Royal Blue", swatch: "rgb(79 130 246)" },
  { id: "emerald", name: "Emerald", swatch: "rgb(16 185 129)" },
  { id: "crimson", name: "Crimson", swatch: "rgb(225 29 72)" },
  { id: "amethyst", name: "Amethyst", swatch: "rgb(168 85 247)" },
  { id: "platinum", name: "Platinum", swatch: "rgb(191 201 214)" },
  { id: "amber", name: "Amber", swatch: "rgb(245 158 11)" },
  { id: "cyan", name: "Cyan", swatch: "rgb(34 211 238)" },
];

export const applyTheme = (id) => {
  document.documentElement.dataset.theme = id || "gold";
};

export const ThemeSwitcher = () => {
  const [open, setOpen] = useState(false);
  const [theme, setTheme] = useState(() => localStorage.getItem("jv-theme") || "gold");
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const pick = (id) => {
    setTheme(id);
    localStorage.setItem("jv-theme", id);
    applyTheme(id);
    setOpen(false);
  };

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((o) => !o)}
        aria-label="Change theme colour"
        data-testid="theme-switcher-btn"
        className="w-9 h-9 rounded-full border border-hairline flex items-center justify-center text-inkmuted hover:text-gold hover:border-gold/50 transition-colors"
      >
        <Palette className="w-4 h-4" />
      </button>
      {open && (
        <div
          className="absolute right-0 mt-2 w-52 glass-card rounded-2xl p-3 z-[70]"
          data-testid="theme-menu"
        >
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-inkfaint px-2 pb-2">Accent colour</p>
          <div className="grid grid-cols-2 gap-1.5">
            {THEMES.map((t) => (
              <button
                key={t.id}
                onClick={() => pick(t.id)}
                data-testid={`theme-option-${t.id}`}
                className="flex items-center gap-2 rounded-xl px-2.5 py-2 hover:bg-surface transition-colors text-left"
              >
                <span className="w-4 h-4 rounded-full shrink-0 ring-1 ring-hairline" style={{ background: t.swatch }} />
                <span className="text-[12px] text-inkmuted truncate flex-1">{t.name}</span>
                {theme === t.id && <Check className="w-3.5 h-3.5 text-gold shrink-0" />}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
